import type { TourConfig } from '../../types/tour.types'

// List Builder — RESULTS state (filters applied, companies/contacts showing).
// Shares the ListBuilder route with the empty-state tour; the `condition` (the
// results tabs card being on screen) decides which one is active. Auto-starts the
// first time results appear (the engine watches the DOM for this state).
const listBuilderResultsTour: TourConfig = {
  id: 'listbuilder-results',
  title: 'Work with your results',
  module: 'Prospecting',
  routeName: 'ListBuilder',
  order: 3,
  autoStart: true,
  condition: () => !!document.querySelector('[data-tour="lb-results-tabs"]'),
  steps: [
    {
      id: 'intro',
      title: 'Your results are in',
      body: 'Now that companies are matching, here\'s how to turn them into a working list — switch views, save the search, and push leads out to where you work.',
    },
    {
      id: 'counts',
      target: '[data-tour="lb-results-count"]',
      placement: 'bottom',
      optional: true,
      title: 'How big is your market',
      body: 'These tiles show how many **companies** match and how many **contacts** sit inside them — your total addressable market for this search. Add filters to focus it, or widen them to grow it.',
    },
    {
      id: 'tabs',
      target: '[data-tour="lb-results-tabs"]',
      placement: 'bottom',
      title: 'Companies or the people inside them',
      body: 'Switch between **Companies** and **View Contacts** for the same search — accounts on one tab, the individuals to reach on the other. Happy with the search? **Save Search** to reuse it any time.',
    },
    {
      id: 'bulk',
      target: '[data-tour="lb-bulk-actions"]',
      placement: 'bottom',
      title: 'Select, list, and export',
      body: 'Select companies (or select all matches), then **Add companies to a List** to keep working them, or **Export Companies** to download them or push straight to your CRM.',
    },
    {
      id: 'table',
      target: '[data-tour="lb-results-table"]',
      placement: 'top',
      title: 'Pick exactly who you want',
      body: 'Use the checkboxes to choose individual companies, or the header checkbox to grab the whole page. Only what you select is added or exported — so you never spend credits on rows you don\'t want.',
    },
    {
      id: 'refine',
      target: '.filter-sidebar-wrap',
      placement: 'end',
      title: 'Keep narrowing to raise quality',
      body: 'Add more filters at any time to tighten these results. Fewer, better-fit companies almost always beats a huge list — it\'s how you keep reply rates high and credits low.',
      aiAction: {
        prompt: 'Suggest additional filters that would make my current List Builder results smaller and higher quality.',
        label: 'Ask AI how to refine this list',
      },
    },
  ],
}

export default listBuilderResultsTour
